

let isEnabled: any;
function checkIfPlaybackForAnonymousUsersEnabled() {
    if (typeof isEnabled !== 'undefined') {
        return isEnabled;
    }

    try {
        const isFeatureEnabled = window.dazn.features.isEnabledAnonymous(
            'f_ar_anonymous_playback'
        );
        isEnabled = isFeatureEnabled;
        return isFeatureEnabled;
    } catch (e) {
        return false;
    }
}

export { checkIfPlaybackForAnonymousUsersEnabled };